import { Button } from '@mui/material';
import { Result } from 'antd';
import AppHelmet from 'components/AppHelmet';
import { useLanguage } from 'lib/i18n/LanguageProvider';
import { useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';
import notFoundBanner from 'assets/svgs/404.svg';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <main className="flex h-screen w-screen items-center justify-center p-15 dark:bg-accent">
      <AppHelmet title={t('khong_tim_thay_trang')} />
      <Result
        icon={<img src={notFoundBanner} alt="404" width={350} height={350} />}
        title={
          <strong className="text-2xl">{t('khong_tim_thay_trang')}</strong>
        }
        subTitle={t('trang_ban_tim_kiem_khong_ton_tai_vui_long_quay_lai_trang_truoc_hoac_tro_lai_trang_chu')}
        extra={
          <div className="flex justify-center gap-x-4">
            <Button variant="outlined" onClick={() => navigate(-1)}>
              {t('quay_lai_trang_truoc')}
            </Button>
            <Button onClick={() => navigate(getPath('portalPage'))}>
              {t('ve_trang_chu')}
            </Button>
          </div>
        }
      />
    </main>
  );
};

export default NotFoundPage;
